module.exports = __webpack_public_path__ + "img/yd2@2x.71b63dee.png";